import * as React from "react"
import Badge from '@mui/material/Badge';
import Grid from "@mui/material/Grid"
import IconButton from "@mui/material/IconButton"
import {
    DataGrid,
} from "@mui/x-data-grid"
import { MobileDateTimePicker } from '@mui/x-date-pickers';
import dayjs from 'dayjs';
import utc from "dayjs/plugin/utc";
import { ceil, updateRentalItemsAvailability } from "../../Utils";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AXIOS_API_INSTANCE } from "../../Constants"
import { send_authorized_request } from "../../Constants/cognito"
import axios from "axios"
import { useSnackbar } from 'notistack';

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SearchIcon from '@mui/icons-material/Search';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import { SimpleCustomToolbar } from "../CustomToolbar"
import onFilterChange from "../../Utils/OnFilterChange"
import { useTrackedLocation } from "../UserState"
import { update_cart, useTrackedReservationCart } from "../CheckoutState"
import { Box, Button, InputAdornment, TextField, debounce } from "@mui/material"
import RentalItemRow from "./RentalItemRow";
import CartDrawer from "../CartDrawer";
import { LoadingBackdropIndeterminate } from "../LoadingBackdrop";
import CartPage from "../CartPage";
import ReserveAvailabilityModal from "./modals/ReserveAvailabilityModal";
import ReservePricePreview from "./ReservePricePreview";
import { useCookies } from "react-cookie";
dayjs.extend(utc);
dayjs.extend(ceil);

const rentalType_columns = [
    {
        field: "name",
        headerName: "Type",
        flex: true,
        editable: false,
        filterable: false,
    },
    {
        field: "rental_category:name",
        headerName: "Category",
        flex: true,
        editable: false,
        sortable: false,
        filterable: false,
        valueGetter: (value, row) => {
            return `${row.rental_category.name || ''}`;
        },
    },
    // {
    //     field: "rental_items:count",
    //     headerName: "# Items",
    //     flex: true,
    //     editable: false,
    //     sortable: false,
    //     filterable: false,
    //     valueGetter: (params) => {
    //         return `${params.row.rental_items || ''}`;
    //     },
    // },
]

function Reserve(props) {
    const { enqueueSnackbar } = useSnackbar();
    const [selectedLocation,] = useTrackedLocation(); // REMOVED setSelectedLocation to make linter happy
    const [cookies, setCookie] = useCookies(["pagination"])
    const [reservationCart, setReservationCart] = useTrackedReservationCart();
    const [rentalItemsSorting,] = React.useState({ field: 'id', sort: 'asc' })
    const [rentalItemsFiltering,] = React.useState({})
    const [rentalTypeSorting, setRentalTypeSorting] = React.useState({ field: 'id', sort: 'asc' })
    const [rentalTypeFiltering, setRentalTypeFiltering] = React.useState({})
    const [rentalTypeSearch, setRentalTypeSearch] = React.useState('')
    const [selectedRentalType, setSelectedRentalType] = React.useState({})
    const [reserveStartDate, setReserveStartDate] = React.useState(dayjs().ceil('minutes', 15))
    const [reserveEndDate, setReserveEndDate] = React.useState(dayjs().ceil('minutes', 15).add(4, 'hour'))
    const [paginationModel, setPaginationModel] = React.useState({
      pageSize: cookies.pagination?.reserve_pageSize || 10,
      page: 0,
    });
    const [rentalTypeRowData, setRentalTypeRowData] = React.useState({ rows: [], total_count: 0 })
    const [rentalItemsRowData, setRentalItemsRowData] = React.useState(undefined)
    const [isLoading, setIsLoading] = React.useState(true)
    const [cartOpen, setCartOpen] = React.useState(true)
    const [cartPageOpen, setCartPageOpen] = React.useState(false)
    const [availabilityModalOpen, setAvailabilityModalOpen] = React.useState(false)

    const setMyPaginationModel = (model) => {
        setCookie(
            "pagination",
            { ...cookies.pagination, reserve_pageSize: model.pageSize },
            { path: "/" }
        )
        setPaginationModel(model)
    }

    const rentalTypeRowClick = (data) => {
        if(!isLoading){
            setSelectedRentalType(data.row)
        }
    }
    const addToCart = (item) => {
        console.log(item)
        // Check for item already in cart
        const inCart = undefined !== reservationCart.cart.find((cart_item) => item.id === cart_item.id)
        const foundDifferentLocation = undefined !== reservationCart.cart.find((cart_item) => item.location.id !== cart_item.location.id)
        item.quantity = 1
        if (!inCart) {
            if (foundDifferentLocation) {
                enqueueSnackbar(`Cannot add items from multiple locations to one reservation`, { variant: 'error' })
                return
            }
            item.rental_type = selectedRentalType
            update_cart({ ...reservationCart, cart: reservationCart.cart.concat([item]) }, reservation_length, reserveStartDate, reserveEndDate, setReservationCart)
        }

    }
    const updateRentalTypeSearch = (event) => {
        setRentalTypeSearch(event.target.value.trim())
        if (event.target.value.trim() !== rentalTypeSearch) {
            debouncedGetRentalType(rentalTypeSorting.field, rentalTypeSorting.sort, rentalTypeFiltering, event.target.value.trim())
        }
    }

    const backButton = () => {
        if (!isLoading) {
            setRentalItemsRowData(undefined)
            setSelectedRentalType(undefined)
        }
    }

    const getRentalType = (sortField, sortDirection, filterVar, rentalTypeSearch) => {
        setIsLoading(true)
        let my_filters = Object.assign({}, filterVar);
        if (rentalTypeSearch.length > 0) {
            my_filters['or'] = []
            my_filters['or'].push({ 'rental_category:name.ilike': rentalTypeSearch })
            my_filters['or'].push({ 'name.ilike': rentalTypeSearch })
        }
        send_authorized_request(() =>
            axios
                .all([
                    AXIOS_API_INSTANCE.get("rentaltype", {
                        params: {
                            page_num: paginationModel.page,
                            page_size: paginationModel.pageSize,
                            order_by: sortField,
                            order_by_direction: sortDirection,
                            filters: JSON.stringify(my_filters),
                        },
                    }),
                ])
                .then(
                    axios.spread((customer) => {
                        console.log(customer)
                        setRentalTypeRowData({
                            rows: customer.data.data,
                            total_count: customer.data.total_count,
                        })
                        setIsLoading(false)
                    })
                )
        )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const debouncedGetRentalType = React.useMemo(() => debounce((sortField, sortDirection, filterVar, rentalTypeSearch) => getRentalType(sortField, sortDirection, filterVar, rentalTypeSearch), 400), []);

    const getRentalItems = (sortField, sortDirection, filterVar) => {
        setIsLoading(true)
        let my_filters = Object.assign({}, filterVar);
        if (selectedLocation.id !== "all") {
            my_filters['location_id.eq'] = selectedLocation.id
        }
        my_filters['rental_type_id.eq'] = selectedRentalType.id
        send_authorized_request(() =>
            axios
                .all([
                    AXIOS_API_INSTANCE.get("rentalitems", {
                        params: {
                            // page_num: page,
                            // page_size: pageSize,
                            order_by: sortField,
                            order_by_direction: sortDirection,
                            filters: JSON.stringify(my_filters)
                        },
                    }),
                ])
                .then(
                    axios.spread((rental_items) => {
                        console.log(rental_items)
                        send_authorized_request(() =>
                            AXIOS_API_INSTANCE.get("rentalcontractitems", {
                                params: {
                                    filters: JSON.stringify({
                                        and: [
                                            // { 'estimated_start_date.lt': reserveEndDate },
                                            // { 'estimated_end_date.gt': reserveStartDate },
                                            { 'estimated_end_date.gt': dayjs.utc() },
                                            { or: rental_items.data.data.map((item) => { return { 'rental_item_id.eq': item.id } }) }
                                        ]
                                    })
                                },
                            }).then((rental_contract_items) => {
                                console.log(rental_contract_items)
                                setRentalItemsRowData({
                                    rows: rental_items.data.data.map((rentalItem) => {
                                        rentalItem.rental_contract_items = []
                                        rental_contract_items.data.data.forEach((item) => {
                                            if (item.rental_item_id === rentalItem.id) {
                                                rentalItem.rental_contract_items.push(item)
                                            }
                                        })
                                        return updateRentalItemsAvailability(rentalItem, reserveStartDate, reserveEndDate)
                                    }),
                                    total_count: rental_items.data.total_count,
                                })
                                setIsLoading(false)
                            })
                        )
                    })
                )
        )
    }


    React.useEffect(() => {
        getRentalType(rentalTypeSorting.field, rentalTypeSorting.sort, rentalTypeFiltering, rentalTypeSearch)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [paginationModel, rentalTypeSorting, rentalTypeFiltering])

    React.useEffect(() => {
        if (selectedRentalType?.id !== undefined) {
            getRentalItems(rentalItemsSorting.field, rentalItemsSorting.sort, rentalItemsFiltering)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedLocation, selectedRentalType, rentalItemsSorting, rentalItemsFiltering])

    React.useEffect(() => {
        const reservation_length = Math.ceil(reserveEndDate.diff(reserveStartDate, 'minutes') / 60)
        if (rentalItemsRowData) {
            setRentalItemsRowData({
                ...rentalItemsRowData,
                rows: rentalItemsRowData.rows.map((item) => updateRentalItemsAvailability(item, reserveStartDate, reserveEndDate))
            })
        }
        update_cart({ ...reservationCart }, reservation_length, reserveStartDate, reserveEndDate, setReservationCart)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [reserveStartDate, reserveEndDate])

    const reservation_length = Math.ceil(reserveEndDate.diff(reserveStartDate, 'minutes') / 60)

    return (
        (<React.Fragment>
            {!cartPageOpen &&
                <Box sx={{ display: 'flex', width: '100%' }}>
                    <Grid container space={1} flexGrow={1} sx={[{
                        transition: 'margin-right 0.25s ease'
                    }, cartOpen ? {
                        mr: 0
                    } : {
                        mr: '-375px'
                    }, cartOpen ? {
                        pr: 1
                    } : {
                        pr: 0
                    }]}>
                        <Grid xs>
                            <Grid container space={1} alignItems="center" justifyContent={"flex-end"}>
                                <Grid xs>
                                    {!rentalItemsRowData &&
                                        <TextField
                                            autoFocus
                                            margin="dense"
                                            id="reservesearch"
                                            label="Search type or category"
                                            type="text"
                                            variant="filled"
                                            disabled={isLoading}
                                            value={rentalTypeSearch}
                                            onChange={updateRentalTypeSearch}
                                            slotProps={{
                                                input: {
                                                    inputProps: { min: 1 },
                                                    startAdornment: (
                                                        <InputAdornment position="start">
                                                            {<SearchIcon />}
                                                        </InputAdornment>
                                                    ),
                                                }
                                            }}
                                        />
                                    }
                                    {rentalItemsRowData &&
                                        <Box>
                                            <Grid container spacing={1}>
                                                <Grid xs="auto">
                                                    <Box onClick={() => backButton()}>
                                                        <IconButton color="inherit">
                                                            <ArrowBackIcon />
                                                        </IconButton>
                                                    </Box>
                                                </Grid>
                                                <Grid item>
                                                    <Box sx={{ display: 'contents' }}>
                                                        <span style={{ display: 'flex', height: '100%', alignItems: 'center' }}><b>{selectedRentalType.name}</b></span>
                                                    </Box>
                                                </Grid>
                                                <Grid item>
                                                    <ReservePricePreview
                                                        reservation_length={reservation_length}
                                                        selectedRentalType={selectedRentalType}
                                                    />
                                                </Grid>
                                                <Grid item>
                                                    <Button variant="contained" onClick={() => setAvailabilityModalOpen(true)} >
                                                        Availability
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                        </Box>
                                    }
                                </Grid>
                                <Grid xs="auto">
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <Grid container spacing={1}>
                                            <Grid xs>
                                                <MobileDateTimePicker
                                                    value={reserveStartDate}
                                                    label="Start Time"
                                                    onChange={(newValue) => {
                                                        setReserveStartDate(newValue)
                                                    }}
                                                    onAccept={(newValue) => {
                                                        if (newValue > reserveEndDate) {
                                                            setReserveEndDate(newValue.add(15, 'minutes'))
                                                        }
                                                    }}
                                                    minutesStep={15}
                                                    onError={console.log}
                                                    renderInput={(params) => <TextField {...params} />}
                                                    minDateTime={dayjs().ceil('minutes', 15)}
                                                    format="YYYY/MM/DD hh:mm a"
                                                    mask="____/__/__ __:__ _M"
                                                />
                                            </Grid>
                                            <Grid xs>
                                                <MobileDateTimePicker
                                                    value={reserveEndDate}
                                                    label="End Time"
                                                    onChange={(newValue) => {
                                                        setReserveEndDate(newValue)
                                                    }}
                                                    minutesStep={15}
                                                    onError={console.log}
                                                    renderInput={(params) => <TextField {...params} />}
                                                    minDateTime={reserveStartDate.add(15, 'minutes')}
                                                    format="YYYY/MM/DD hh:mm a"
                                                    mask="____/__/__ __:__ _M"
                                                />
                                            </Grid>
                                        </Grid>
                                    </LocalizationProvider>
                                </Grid>
                                {!cartOpen &&
                                    <Grid xs="auto" sx={{ pr: 1, pl: 1 }}>
                                        <Box onClick={() => setCartOpen(true)}>
                                            <IconButton color="inherit">
                                                <Badge badgeContent={reservationCart.cart.length} color="error">
                                                    <AddShoppingCartIcon />
                                                </Badge>
                                            </IconButton>
                                        </Box>
                                    </Grid>
                                }
                            </Grid>
                            {!rentalItemsRowData &&
                                <Box>
                                    <DataGrid
                                        slots={{
                                            toolbar: () => SimpleCustomToolbar(),
                                        }}
                                        rows={rentalTypeRowData.rows}
                                        rowCount={rentalTypeRowData.total_count}
                                        columns={rentalType_columns}
                                        disableRowSelectionOnClick
                                        experimentalFeatures={{ newEditingApi: true }}
                                        autoHeight={true}
                                        loading={isLoading}
                                        pageSizeOptions={[5, 10, 20, 50, 100]}
                                        pagination
                                        paginationMode="server"
                                        paginationModel={paginationModel}
                                        onPaginationModelChange={setMyPaginationModel}
                                        filterMode={"server"}
                                        onRowClick={rentalTypeRowClick}
                                        onSortModelChange={(params) => {
                                            if (params[0] !== undefined) {
                                                setRentalTypeSorting(params[0])
                                            } else {
                                                setRentalTypeSorting({ field: 'id', sort: 'asc' })
                                            }
                                        }}
                                        onFilterModelChange={(params) => { setRentalTypeFiltering(onFilterChange(params)) }}
                                    />
                                </Box>
                            }
                            {rentalItemsRowData &&
                                <Box sx={{
                                    '& .reservation-status-unavailable': {
                                        bgcolor: () => '#ef5350'
                                    },
                                    '& .reservation-status-available': {
                                        bgcolor: () => '#4caf50'
                                    },
                                    '& .reservation-status-unavailable-tooltip': {
                                        height: '100%',
                                        width: '100%',
                                        display: 'flex',
                                        alignItems: 'center'
                                    },
                                    pt: 1
                                }}>
                                    <LoadingBackdropIndeterminate
                                        open={isLoading}
                                        text="Loading Rental Items"
                                    />
                                    {rentalItemsRowData?.rows.length === 0 && !isLoading &&
                                        <Box textAlign={'center'}>
                                            <h1>{selectedLocation.id !== "all" ? "No items at this location" : "No items"}</h1>
                                        </Box>
                                    }
                                    {rentalItemsRowData?.rows.map((item) => (
                                        <RentalItemRow
                                            key={item.id}
                                            item={item}
                                            cart={reservationCart.cart}
                                            addToCartFunction={addToCart}
                                            showCalendar={true}
                                        />
                                    ))}
                                </Box>}
                        </Grid>
                    </Grid>
                    <CartDrawer
                        open={cartOpen}
                        setCartOpen={setCartOpen}
                        reserveStartDate={reserveStartDate}
                        reserveEndDate={reserveEndDate}
                        reservation_length={reservation_length}
                        goToCartPage={() => setCartPageOpen(true)}
                    />
                    {availabilityModalOpen &&
                        <ReserveAvailabilityModal
                            reserveStartDate={reserveStartDate}
                            setReserveStartDate={setReserveStartDate}
                            reserveEndDate={reserveEndDate}
                            setReserveEndDate={setReserveEndDate}
                            items={rentalItemsRowData?.rows}
                            open={availabilityModalOpen}
                            closeModal={() => setAvailabilityModalOpen(false)}
                        />
                    }
                </Box>
            }
            <CartPage
                reserveStartDate={reserveStartDate}
                setReserveStartDate={setReserveStartDate}
                reserveEndDate={reserveEndDate}
                setReserveEndDate={setReserveEndDate}
                reservation_length={reservation_length}
                closeCartPage={() => setCartPageOpen(false)}
                open={cartPageOpen}
            />
        </React.Fragment>)
    );
}

export default Reserve
